export const SenpiRecap = ({ rows }) => {
  const total = (r) => r.BAIK + r["RUSAK RINGAN"] + r["RUSAK BERAT"] + r.LAINNYA;
  return (
    <section className="border bg-card self-start" data-testid="senpi-recap">
      <div className="px-5 py-4 border-b">
        <h2 className="font-heading font-bold text-base md:text-lg">Rekap Senpi per Merk / Model</h2>
        <p className="text-xs text-muted-foreground mt-0.5">Dihitung otomatis dari data pemegang senpi (pucuk)</p>
      </div>
      <table className="w-full text-sm">
        <thead className="bg-muted">
          <tr className="text-left border-b">
            <th className="px-5 py-2.5 eyebrow">Merk / Model</th>
            <th className="px-3 py-2.5 eyebrow text-right">Baik</th>
            <th className="px-3 py-2.5 eyebrow text-right">R. Ringan</th>
            <th className="px-3 py-2.5 eyebrow text-right">R. Berat</th>
            <th className="px-5 py-2.5 eyebrow text-right">Jumlah</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.model} className="border-b last:border-0" data-testid={`senpi-row-${r.model}`}>
              <td className="px-5 py-2.5 font-medium">{r.model}</td>
              <td className="px-3 py-2.5 text-right font-mono">{r.BAIK}</td>
              <td className="px-3 py-2.5 text-right font-mono">{r["RUSAK RINGAN"]}</td>
              <td className="px-3 py-2.5 text-right font-mono">{r["RUSAK BERAT"]}</td>
              <td className="px-5 py-2.5 text-right font-mono font-semibold">{total(r)}</td>
            </tr>
          ))}
          <tr className="bg-muted/60 font-semibold">
            <td className="px-5 py-2.5">TOTAL</td>
            <td colSpan={3} />
            <td className="px-5 py-2.5 text-right font-mono" data-testid="senpi-total">{rows.reduce((a, r) => a + total(r), 0)}</td>
          </tr>
        </tbody>
      </table>
    </section>
  );
};
